import React from 'react';
import PropTypes from 'prop-types';

const ComparePopupContentShowDifferences = ({
  showDifferences,
  seeDifferencesLabel,
  onToggleShowDifferences,
}) => (
  <section className='ken-compare__popup__show-differences'>
    <button
      type='button'
      className={`${showDifferences ? '--show-differences' : ''}`}
      onClick={onToggleShowDifferences}
    >
      {seeDifferencesLabel}
    </button>
  </section>
);

ComparePopupContentShowDifferences.propTypes = {
  showDifferences: PropTypes.bool,
  seeDifferencesLabel: PropTypes.string.isRequired,
  onToggleShowDifferences: PropTypes.func,
};

ComparePopupContentShowDifferences.defaultProps = {
  showDifferences: false,
  onToggleShowDifferences: null,
};

export default ComparePopupContentShowDifferences;
